import { useTranslation } from 'react-i18next';
import { Slider } from '@/components/ui/slider';

interface YearRangeFilterProps {
  min: number;
  max: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
  className?: string;
}

export default function YearFilter({
  min,
  max,
  value,
  onChange,
  className,
}: YearRangeFilterProps) {
  const { t } = useTranslation('common');
  const [from, to] = value;

  return (
    <div
      className={`flex flex-col gap-1.5 min-w-[260px] sm:min-w-[320px] ${className ?? ''}`}
    >
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ctu-text-muted">
          {t('filterByYear')}
        </span>
        <span className="text-xs font-mono tabular-nums text-ctu-text">
          {from === to ? from : `${from} – ${to}`}
        </span>
      </div>
      <Slider
        min={min}
        max={max}
        step={1}
        minStepsBetweenThumbs={0}
        value={[from, to]}
        onValueChange={(v: number[]) => {
          if (v.length < 2) return;
          const lo = Math.min(v[0], v[1]);
          const hi = Math.max(v[0], v[1]);
          onChange([lo, hi]);
        }}
      />
      <div className="flex justify-between text-[10px] font-mono tabular-nums text-ctu-text-muted">
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  );
}
